import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import Welcome from "./components/Welcome";
import Dashboard from "./components/Dashboard";
import Devices from "./components/Devices";
import FullMap from "./components/FullMap";
import Login from "./components/Login";
import Users from "./components/Users";
import Reports from "./components/Reports";
import Settings from "./components/Settings";
import FilteredView from "./components/FilteredView";
import IntervalData from "./components/IntervalData";
import Alerts from "./components/Alerts";
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import Blinks from "./components/blinks";
import BlinkAnalyzer from "./components/BlinkAnalyzer";
import FaultZones from "./components/FaultZones";
import PingHistoryTab from "./components/PingHistoryTab";
import IntervalHistory from "./components/IntervalHistory";

function App() {
  const [token, setToken] = useState(null);

  useEffect(() => {
    // Check if token exists in localStorage on page load (after refresh)
    const storedToken = localStorage.getItem("token");
    if (storedToken) setToken(storedToken);
  }, []);

  // This will handle redirecting if the user is not logged in
  const ProtectedRoute = ({ children }) => {
    return token ? children : <Navigate to="/" />;
  };

  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={token ? <Navigate to="/welcome" /> : <Login onLogin={setToken} />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        {/* Protected Routes */}
        <Route
          path="/welcome"
          element={token ? <ProtectedRoute><Welcome /></ProtectedRoute> : <Navigate to="/" />}
        />
        <Route
          path="/dashboard"
          element={token ? <ProtectedRoute><Dashboard /></ProtectedRoute> : <Navigate to="/" />}
        />
        <Route
          path="/devices"
          element={token ? <ProtectedRoute><Devices /></ProtectedRoute> : <Navigate to="/" />}
        />
        <Route
          path="/map"
          element={token ? <ProtectedRoute><FullMap /></ProtectedRoute> : <Navigate to="/" />}
        />
        <Route
          path="/users"
          element={token ? <ProtectedRoute><Users /></ProtectedRoute> : <Navigate to="/" />}
        />
        <Route
          path="/reports"
          element={token ? <ProtectedRoute><Reports /></ProtectedRoute> : <Navigate to="/" />}
        />
        <Route
          path="/settings"
          element={token ? <ProtectedRoute><Settings /></ProtectedRoute> : <Navigate to="/" />}
        />
        <Route
          path="/intervals"
          element={<IntervalData />}
        />
        <Route
          path="/alerts"
          element={token ? <ProtectedRoute><Alerts /></ProtectedRoute> : <Navigate to="/" />}
        />
        <Route
          path="/filtered/blinks"
          element={token ? <ProtectedRoute><FilteredView type="blinks" /></ProtectedRoute> : <Navigate to="/" />}
        />
        <Route
          path="/blinks"
          element={token ? <ProtectedRoute><Blinks /></ProtectedRoute> : <Navigate to="/" />}
        />
        <Route
          path="/blink-analyzer"
          element={token ? <ProtectedRoute><BlinkAnalyzer /></ProtectedRoute> : <Navigate to="/" />}
        />
        <Route
          path="/fault-zones"
          element={token ? <ProtectedRoute><FaultZones /></ProtectedRoute> : <Navigate to="/" />}
        />
        <Route path="/ping-history" element={<ProtectedRoute><PingHistoryTab /></ProtectedRoute>} />
        <Route path="/interval-history" element={<IntervalHistory />} />

        {/* New filtered routes */}
        <Route
          path="/filtered/online"
          element={token ? <ProtectedRoute><FilteredView type="online" /></ProtectedRoute> : <Navigate to="/" />}
        />
        <Route
          path="/filtered/offline"
          element={token ? <ProtectedRoute><FilteredView type="offline" /></ProtectedRoute> : <Navigate to="/" />}
        />
        <Route
          path="/filtered/outages"
          element={token ? <ProtectedRoute><FilteredView type="outages" /></ProtectedRoute> : <Navigate to="/" />}
        />
        <Route
          path="/filtered/alerts"
          element={token ? <ProtectedRoute><FilteredView type="alerts" /></ProtectedRoute> : <Navigate to="/" />}
        />
      </Routes>
    </Router>
  );
}

export default App;
